import moment from 'moment';
import {statusTypes} from "../config/constants";

// Make sure it's a string and has at least 1 character entered
export const getStringValidationState = (state) => {
  if (typeof state !== 'string')
    return statusTypes.ERROR;
  const length = state.length;
  return length > 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
};

// Make sure the state exists in the list
export const getEnumValidationState = (state, element) => {
  return element.options.includes(state) ? statusTypes.SUCCESS : statusTypes.ERROR;
};

// Make sure the value is true
export const getBooleanValidationState = (state) => {
  return !!state ? statusTypes.SUCCESS : statusTypes.ERROR;
};

// Make sure the value is a 4 digit integer higher than 1950 and no higher than the current year
export const getYearValidationState = (state) => {
  const status = getStringValidationState(state);
  const year = parseInt(state, 10);
  const currentYear = new Date().getFullYear();
  return status === statusTypes.ERROR ? status :
    state.length !== 4 ? statusTypes.ERROR :
      isNaN(state) ? statusTypes.ERROR :
        year > 1950 && year <= currentYear ? statusTypes.SUCCESS : statusTypes.ERROR;
};

export const getDateValidationState = (state) => {
  return typeof state !== 'undefined' && moment(state).isValid() ? statusTypes.SUCCESS : statusTypes.ERROR;
};

// Make sure the value is a number and not blank
export const getNumericValidationState = (state) => {
  const status = getStringValidationState(state);
  return status === statusTypes.ERROR ? status :
    isNaN(state) ? statusTypes.ERROR :
      statusTypes.SUCCESS
};

// Make sure it's a string with an @ sign and a domain
export const getEmailValidationState = (state) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const status = getStringValidationState(state);
  return status === statusTypes.ERROR ? status :
    re.test(String(state).toLowerCase()) ? statusTypes.SUCCESS :
      statusTypes.ERROR;
};

export const getValidationState = function (state) {
  let status = {
    section: {
      message: 'Section Complete',
      invalidElements: [],
      status: statusTypes.SUCCESS
    }
  };
  for (const rule in this.rules) {
    const {validationMethod, id, path, errorMsg} = this.rules[rule];
    let _state = state;
    if (path) // Path means we're not at the root of the object
      path.forEach(function (level) {
        _state = _state[level];
      });
    const elementStatus = this[validationMethod](_state[id], this.rules[rule]);
    status[rule] = elementStatus;
    if (elementStatus !== statusTypes.SUCCESS) {
      status.section.status = statusTypes.DANGER;
      status.section.message = 'Invalid Elements';
      status.section.invalidElements.push(errorMsg);
    }
  }
  return status;
};

export default {
  getStringValidationState,
  getEnumValidationState,
  getBooleanValidationState,
  getYearValidationState,
  getDateValidationState,
  getNumericValidationState,
  getEmailValidationState
};